module.exports = __webpack_public_path__ + "img/P3-en.de169f81.png";